import { forwardRef } from 'react';
import Link, { type LinkProps } from '@liquidweb-dev/undercurrent/Link';
import useLeftHandLayout from '../context';

export interface HookedLinkProps extends Omit<LinkProps, 'href'> {
	href?: string;
}

export const HookedLink = forwardRef<HTMLAnchorElement, HookedLinkProps>(
	(props, ref) => {
		const { href, ...linkProps } = props;

		const { linkComponent, linkProp = 'href' } = useLeftHandLayout();

		return (
			<Link
				ref={ref}
				component={linkComponent}
				{...{ [linkProp]: href }}
				{...linkProps}
			/>
		);
	},
);

HookedLink.displayName = 'HookedLink';

export default HookedLink;
